module.exports = __webpack_public_path__ + "img/img_preview.31efc291.svg";